<template>
    <basic-container>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="审批人">
                <el-input v-model="formInline.user" placeholder="审批人"></el-input>
            </el-form-item>
            <el-form-item label="活动区域">
                <el-select v-model="formInline.region" placeholder="活动区域">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <div style="padding:1rem 0;">
            <el-button type="primary" size="small" @click="handleAdd" >新增</el-button>    
        </div>
        <el-table
            :data="tableData"
            border
            >
            <el-table-column
            fixed
            prop="date"
            label="日期"
            >
            </el-table-column>
            <el-table-column
            prop="name"
            label="姓名"
            >
            </el-table-column>
            <el-table-column
            prop="province"
            label="省份"
            >
            </el-table-column>
            <el-table-column
            prop="city"
            label="市区"
            >
            </el-table-column>
            <el-table-column
            prop="address"
            label="地址"
            >
            </el-table-column>
            <el-table-column
            prop="zip"
            label="邮编"
            >
            </el-table-column>
            <el-table-column
            fixed="right"
            label="操作"
            >
            <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                <el-button type="text" size="small">编辑</el-button>
            </template>
            </el-table-column>
        </el-table>
        <el-dialog title="收货地址" :visible.sync="addDialogFormVisible" append-to-body	fullscreen>
            <!-- <avue-form :option="option" v-model="obj" @submit="handleSubmit">
            </avue-form> -->
            <el-table
            :data="tableData"
            border
            >
                <el-table-column
                fixed
                prop="date"
                label="字段名称"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="字段备注"
                >
                </el-table-column>
                <el-table-column
                prop="province"
                label="字段长度"
                >
                </el-table-column>
                <el-table-column
                prop="city"
                label="小数点"
                >
                </el-table-column>
                <el-table-column
                prop="address"
                label="默认值"
                >
                </el-table-column>
                <el-table-column
                prop="zip"
                label="字段类型"
                >
                </el-table-column>
                
                <el-table-column
                prop="zip"
                label="主键"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="允许空值"
                >
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                    <el-button type="text" size="small">编辑</el-button>
                </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <test-components />
    </basic-container>
</template>

<script>
import testComponents from '@/components/test-components/test-components'
  export default {
      components:{
          testComponents
      },
    methods: {
      handleClick(row) {
        console.log(row);
      },
      handleAdd(a,b,c){
          this.addDialogFormVisible = !this.addDialogFormVisible;
      },
      handleSubmit(formData,done){
          console.log(formData);
          done();
      },
    },

    data() {
      return {
          obj: {
          dynamic: [{
            input: 1,
            select: 1,
            radio: 1,
          }, {
            input: 2,
            select: 2,
            radio: 1,
          }]
        },
        option: {
          labelWidth: 110,
          column: [
          {
            label: '子表单',
            prop: 'dynamic',
            type: 'dynamic',
            span:24,
            children: {
              align: 'center',
              headerAlign: 'center',
              rowAdd:(done)=>{
                this.$message.success('新增回调');
                  done({
                    input:'默认值'
                  });
              },
              rowDel:(row,done)=>{
                this.$message.success('删除回调'+JSON.stringify(row));
                done();
              },
              column: [{
                width: 2000,
                label: '输入框',
                prop: "input",
              }, {
                width: 200,
                label: '选择框',
                prop: "select",
                type: 'select',
                rules:[{
                  type:'number',
                  require:true,
                  message:'请选择选择框',
                }],
                dicData: [{
                  label: '测试1',
                  value: 1
                }, {
                  label: '测试2',
                  value: 2
                }]
              }, {
                width: 200,
                label: '多选',
                prop: "checkbox",
                type: 'checkbox',
                dicData: [{
                  label: '测试1',
                  value: 1
                }, {
                  label: '测试2',
                  value: 2
                }]
              }, {
                width: 200,
                label: '开关',
                prop: "switch",
                type: 'switch',
                dicData: [{
                  label: '测试1',
                  value: 1
                }, {
                  label: '测试2',
                  value: 2
                }]
              }, {
                width: 200,
                label: '数字框',
                prop: "number",
                type: 'number'
              }]
            }
          },

          ]
        },
          addDialogFormVisible:false,
        formInline: {
          user: '',
          region: ''
        },
        tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }, {
          date: '2016-05-04',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1517 弄',
          zip: 200333
        }, {
          date: '2016-05-01',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1519 弄',
          zip: 200333
        }, {
          date: '2016-05-03',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333
        }]
      }
    }
  }
</script>

<style>

</style>





